import { Box, Button, HStack, Spinner, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Heading } from '~/components';
import { Card } from '~/components/Card';
import logo from '~/assets/logo-service-gray.png';
import { formatInTimeZone } from '~/utils/formatToTimeZone';
import { TextEditor } from '~/components/TextEditor/TextEditor';
import { getPrivacyPolicyById } from '~/services/PrivacyPolicy';

export const PrivacyPolicyDetail: React.VFC = () => {
  const history = useHistory();
  const [isFetching, setIsFetching] = useState(false);
  const { id } = useParams<{ id: string }>();
  const [titulo, setTitulo] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [dataCriacao, setDataCriacao] = useState<string>();
  const [dataPublicacao, setDataPublicacao] = useState<string>();

  useEffect(() => {
    if (id) {
      setIsFetching(true);
      getPrivacyPolicyById(id)
        .then(response => {
          setTitulo(response.descricao);
          setMensagem(response.mensagem);
          if (response.data_criacao) {
            const data = formatInTimeZone(response.data_criacao, 'dd/MM/yyyy');
            setDataCriacao(data);
          }
          if (response.data_publicacao) {
            const data = formatInTimeZone(
              response.data_publicacao,
              'dd/MM/yyyy',
            );
            setDataPublicacao(data);
          }
        })
        .finally(() => setIsFetching(false));
    }
  }, [id]);

  const voltar = () => {
    history.goBack();
  };

  const content = () => {
    return (
      <Stack p={3} gridGap={3}>
        <Text fontSize="24px" fontWeight="bold">
          {titulo}
        </Text>
        <TextEditor value={mensagem} visualizacao />
        <img src={logo} alt="" width="100px" />
      </Stack>
    );
  };

  return (
    <Box px="8" py="4">
      <HStack gridGap={3}>
        <Heading>Termos de Uso</Heading>
        {isFetching && <Spinner />}
      </HStack>
      <HStack
        py={8}
        justifyContent="space-between"
        alignItems="flex-end"
        w="70%"
      >
        <HStack gridGap={4}>
          <HStack>
            <Text fontWeight="bold">Data de criação: </Text>
            <Text>{dataCriacao}</Text>
          </HStack>
          <HStack>
            <Text fontWeight="bold">Data de publicação: </Text>
            <Text>{dataPublicacao ?? '-'}</Text>
          </HStack>
        </HStack>
      </HStack>
      <Card width="70%" content={content()} />
      <HStack justifyContent="flex-end" w="70%">
        <Button
          marginTop="40px"
          variant="outline"
          type="button"
          onClick={() => voltar()}
        >
          Voltar
        </Button>
      </HStack>
    </Box>
  );
};
